var _style, _g, _line, _path, _g2, _polyline, _polyline2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362.98 362.98",
    style: {
      enableBackground: "new 0 0 362.98 362.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A3CAB5;}\n\t.st1{fill:none;stroke:#A3CAB5;stroke-width:20;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#A3CAB5;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:15;}\n\t.st3{fill:#C8DFD3;}\n\t.st4{fill:none;stroke:#C8DFD3;stroke-width:20;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#B5D5C4;stroke-width:25;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#A3CAB5;stroke-width:25;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#DAEAE1;stroke-width:25;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.41,362.98h-0.01C81.33,362.93-0.05,281.47,0,181.4C0.05,81.36,81.46,0,181.49,0c0.03,0,0.06,0,0.09,0 c48.44,0.02,93.99,18.9,128.24,53.16s53.13,79.8,53.16,128.24c-0.03,48.5-18.93,94.08-53.21,128.37 C275.48,344.05,229.9,362.95,181.41,362.98z M181.49,20C92.47,20,20.04,92.39,20,181.41c-0.04,89.04,72.37,161.52,161.4,161.57 c89.04-0.06,161.52-72.54,161.58-161.58C342.94,92.45,270.53,20.04,181.57,20C181.55,20,181.51,20,181.49,20z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 57.85,
    y1: 192.82,
    x2: 293.13,
    y2: 192.82
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M57.85,153.43h98.33c27.68,0,50.11-22.44,50.11-50.11V83.82"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 57.85,
    y1: 231.55,
    x2: 216.16,
    y2: 231.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "181.49,188.34 224.7,231.55 181.49,274.77  "
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "260.35,149.61 303.56,192.82 260.35,236.03 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "163.07,113.67 206.28,70.46 249.5,113.67 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageThree);
export default __webpack_public_path__ + "static/media/image_three.7385bf2229d213444ccf5f2cfb9e5373.svg";
export { ForwardRef as ReactComponent };